<template>
  <el-upload
    class="xo-element-upload"
    action="string"
    :http-request="upload"
    :on-remove="handleRemove"
    :before-remove="beforeRemove"
    :on-preview="handlePreview"
    multiple
    :limit="3"
    :on-exceed="handleExceed"
    :file-list="fileList">
    <el-button size="small" type="primary">点击上传</el-button>
    <div slot="tip" class="el-upload__tip">{{config.tiptxt}}</div>
  </el-upload>
</template>
<script>
  export default {
    props: ['uploadOSSConf', 'files'],
    data() {
      return {
        config: this.uploadOSSConf,
        fileList: this.files
      };
    },
    methods: {
      randomFunc (n) {
        var randomNum='';
        for (var i=0; i<n; i++) { randomNum += Math.floor(Math.random()*10); }
        return randomNum
      },
      upload (params) {
        var self = this
        var name = params.file.name.split('.')[0]
        var type = params.file.name.split('.')[1]
        var tranferType = type.toLowerCase()
        switch (tranferType) {
          case 'mp3' || 'MP3':
            tranferType = 'audio/*'
            break;
          case 'ppt':
            tranferType = 'application/vnd.ms-powerpoint'
            break;
          case 'xls':
            tranferType = 'application/vnd.ms-excel'
            break;
          case 'xlsx':
            tranferType = 'application/vnd.ms-excel'
            break;
          case 'docx':
            tranferType = 'application/msword'
            break;
          case 'txt':
            tranferType = 'text/plain'
          case 'zip':
            tranferType = 'application/zip'
          case 'rar':
            tranferType = 'application/octet-stream'
            break;
        }

        var storeAs
        if (this.config.fileName && this.config.fileName != '') {
          storeAs = this.config.fileName + '.' + type
        } else {
          storeAs = name + '.' + type
        }
        var boolean = true
        if (params.file.size / 1024 > this.config.maxSize) {
          window.alert('文件大小不能超过' + this.config.maxSize / 1024 + 'MB!')
          return false
        }
        if (this.config.typeArr && this.config.typeArr.indexOf(tranferType) > 0) {
          boolean = false
        }
        if (boolean) {
          window.alert('上传文件格式不支持!请选择' + this.config.typeArr)
          return false
        }
        this.client = new OSS.Wrapper({
          accessKeyId: this.config.STS[1],
          accessKeySecret: this.config.STS[2],
          stsToken: this.config.STS[3],
          endpoint: this.config.STS[4],
          bucket: this.config.STS[5]
        })
        var storeDir
        if (this.config.catalog && this.config.catalog !== '') {
          storeDir = this.config.catalog + '/' + new Date().getTime() + this.randomFunc(6) + '/' + storeAs
        } else {
          storeDir = new Date().getTime() + this.randomFunc(6) + '/' + storeAs
        }
        this.client.multipartUpload(storeDir, params.file).then(function (result) {
          let uploadIdStatus = result.res.requestUrls[0].indexOf('?uploadId=');
          if (uploadIdStatus !== -1) {
            result.res.requestUrls[0] = result.res.requestUrls[0].substring(0, uploadIdStatus);
          }
          self.$emit('success', result)
        }).catch(function (err) {
          console.log(err)
        })
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      handlePreview(file) {
        this.$emit('preview', file)
      },
      handleRemove(file) {
        this.$emit('remove', file)
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/upload/uploadOSSbyElem.vue